import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from "../ui/select";

export const MODELS = [
  { value: "claude-sonnet-5", label: "Sonnet 5" },
  { value: "claude-opus-5", label: "Opus 5" },
  { value: "claude-haiku-4-5-20251001", label: "Haiku 4.5" },
];

export function ModelSelector({ value, onChange }) {
  return (
    <Select value={value || "claude-sonnet-5"} onValueChange={onChange}>
      <SelectTrigger data-testid="model-selector-dropdown" className="w-32 font-mono text-xs">
        <SelectValue placeholder="Modelo" />
      </SelectTrigger>
      <SelectContent>
        {MODELS.map((m) => (
          <SelectItem key={m.value} value={m.value} data-testid={`model-option-${m.value}`}>
            {m.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
